<style lang="scss">
.tz-breadcrumbs {
  &__list {
    list-style-type: none;
    padding: 0;
  }
  &__list-item {
    display: inline-block;
    &:last-of-type .tz-breadcrumbs__divider {
      display: none;
    }
  }
  &__divider {
    position: relative;
  }
}
</style>

<template>
  <nav class="tz-breadcrumbs" aria-label="breadcrumbs">
    <ol
      class="tz-breadcrumbs__list"
      :itemscope="hasItemscope"
      :itemtype="hasItemscope ? 'https://schema.org/BreadcrumbList' : false"
    >
      <li
        class="tz-breadcrumbs__list-item"
        v-for="({ href, disabled, text }, index) in items.filter(
          ({ hiddenFromView }) => !hiddenFromView
        )"
        :key="index"
        :itemscope="hasItemscope"
        :itemprop="hasItemscope ? 'itemListElement' : false"
        :itemtype="hasItemscope ? 'https://schema.org/ListItem' : false"
      >
        <a
          v-for="item in renderIf(!disabled)"
          :key="item"
          :itemprop="hasItemscope ? 'item' : false"
          :href="siteUrl + href"
          class="tz-breadcrumbs__link"
          :aria-label="text"
          v-html="hasItemscope ? `<span itemprop='name'>${text}</span>` : text"
        />
        <span
          v-for="item in renderIf(disabled)"
          :key="item"
          class="tz-breadcrumbs__link tz-breadcrumbs__link--disabled"
          :itemprop="hasItemscope ? 'name' : false"
          :aria-disabled="true"
          v-html="text"
        />
        <meta
          v-for="item in renderIf(hasItemscope)"
          :key="item"
          itemprop="position"
          :content="index + 1"
        />
        <span class="tz-breadcrumbs__divider" aria-hidden="true"></span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'tz-breadcrumbs',
  data() {
    return {
      breadcrumbsLd: JSON
    };
  },
  created() {
    if (!this.hasItemscope) {
      this.setBreadcrumbsLd();
    }
  },
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return condition ? [Math.random()] : [];
    },
    setBreadcrumbsLd() {
      this.breadcrumbsLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: []
      };

      this.items.forEach(function(
        { href, text: name, emoji, schemaName },
        index
      ) {
        const position = index + 1;
        let updatedName = name;

        if (schemaName) {
          updatedName = schemaName;
        }

        this.breadcrumbsLd.itemListElement.push({
          '@type': 'ListItem',
          position,
          item: {
            '@id': this.siteUrl + href,
            name: emoji ? `${emoji} ${updatedName}` : updatedName
          }
        });
      },
      this);
    }
  },
  props: {
    // An array of the items we want displayed in the breadcrumbs. Expects format of [{href: string, text: string, disabled: boolean, emoji: string, schemaName: string}]
    items: {
      type: Array,
      required: true
    },
    // The base url for the LD Json url build
    siteUrl: {
      type: String,
      required: true
    },
    // If has itemscope is true it will disable the json schema
    hasItemscope: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  head() {
    if (!this.hasItemscope) {
      return {
        script: [{ type: 'application/ld+json', json: this.breadcrumbsLd }]
      };
    }
  }
};
</script>
